import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalServices } from '../global.services';
import { SubscriptionPlanService } from '../services/subscription-plan.service';

@Component({
  selector: 'app-membership-discount',
  templateUrl: './membership-discount.component.html',
  styleUrls: ['./membership-discount.component.scss']
})
export class MembershipDiscountComponent implements OnInit {

  constructor(
    private router: Router,
    private globalService: GlobalServices,
    private subscriptionPlanService: SubscriptionPlanService
  ) { }

  ngOnInit(): void {
    if(this.globalService?.isBrowser){
      this.globalService?.hideHeader.next(false);
      this.globalService?.hideFooter.next(false);
      this.getSubscriptionPlan();
      this.slickSlider();
    }
  }
  instructorData = [
    { 
      imgSrc:"../../assets/images/instructors/renay.jpg",
      name:"Renay Wright",
      designation:"Yoga Teacher"
    },
    { 
      imgSrc:"../../assets/images/instructors/Michelle-Boss.png",
      name:"Michelle Boss",
      designation:"Personal Finance Coach"
    },
    { 
      imgSrc:"../../assets/images/Sharmila.jpg",
      name:"Sharmila Acharya",
      designation:"Mind-Body Flow Expert"
    },
    { 
      imgSrc:"../../assets/images/instructors/Kathryn.png",
      name:"Kathryn Chess",
      designation:"Nutritionist & Healthy Living Coach"
    },
  ];
  quickViewImages = [
    { imgSrc: "../../assets/images/quickView/1.jpg" },
    { imgSrc: "../../assets/images/quickView/2.jpg" },
    { imgSrc: "../../assets/images/quickView/3.jpg" },
    { imgSrc: "../../assets/images/quickView/4.jpg" },
    { imgSrc: "../../assets/images/quickView/5.jpg" },
    { imgSrc: "../../assets/images/quickView/6.jpg" },
    { imgSrc: "../../assets/images/quickView/7.jpg" },
    { imgSrc: "../../assets/images/quickView/8.jpg" },
    { imgSrc: "../../assets/images/quickView/9.jpg" },
    { imgSrc: "../../assets/images/quickView/10.jpg" },
  ];
  slideConfigForInstructor={};
  slideConfigForVideos = {};
  planInfo;
  getSubscriptionPlan(){
    const token = localStorage.getItem('Token') ? localStorage.getItem('Token') : "";
    this.subscriptionPlanService?.getSubscriptionDetail().subscribe((response: any) => {
      if(response){
        console.log('getSubscriptionPlan', response);
        this.planInfo = response;
      }
    })
  }
  showAlert = false;
  popUpMessage;
  goToFreeSubscription(){
    if(this.planInfo){
      this.router.navigate([`register/${this.planInfo?.data?._id}-discount`])
    }
    else{
      this.showAlert = true;
      this.popUpMessage = "Something went wrong. Please try again !!"
    }
  }
  triggerCloseEvent(){
    this.showAlert = false;
  }
  slickSlider() {
    this.slideConfigForInstructor = {
      "slidesToShow": 4,
      "slidesToScroll": 1,
      "infinite": false,
      "responsive": [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots:true,
            centerMode: true,
            centerPadding: '10px',
          },
        }
      ]
    }
    this.slideConfigForVideos = {
      "slidesToShow": 5,
      "slidesToScroll": 1,
      "infinite": true,
      arrows: false,
      dots:true,
      centerMode: true,
      centerPadding: '200',
      "responsive": [
        {
          breakpoint: 1539,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            dots:true,
            infinite: true,
            centerMode: true,
            centerPadding: '200px',
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: '80px',
            arrows: false,
            dots:true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            dots:true,
            centerMode: true,
            centerPadding: '10px',
          },
        }
      ]
    }
  }
  plan = "Monthly Plan"; //Premium Plan

  public accordianChange(index:number):void{
    if(this.globalService.isBrowser){
    let els:any = document.getElementsByClassName('accordian');
    if(els){
     let el:any = document.getElementsByClassName('accordian')[index];
     if(el.classList.contains('active')){
      el.classList.remove("active");
     }else{
    for(let elem of els){
      elem.classList.remove("active");
    }
     el.classList.add("active");
     }
    }
   }
  }
  scrollToViewOfExploreSection(){
    if(this.globalService?.isBrowser){
      document.getElementById("exploreAWorldOfWellnessDiscountPage").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }
  }
}
